// ABOUTME: The empty-dashboard card: what to do first, with a dismiss that sticks.
// ABOUTME: Dismissal is read on the first render, so a dismissed card never flashes in.
import React, { useState } from "react";

interface FTUXCardProps {
  onAddClick: () => void;
}

const FTUX_DISMISSED_KEY = "ftux_card_dismissed";

const FTUXCard: React.FC<FTUXCardProps> = ({ onAddClick }) => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(FTUX_DISMISSED_KEY) === "1";
    } catch {
      return false;
    }
  });

  const handleDismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(FTUX_DISMISSED_KEY, "1");
    } catch {
      // Storage blocked: the card stays dismissed for this visit only.
    }
  };

  if (dismissed) return null;
  return (
    <div className="w-full rounded-[var(--radius-lg)] bg-[var(--color-bg-secondary)] border border-[var(--color-border)] p-5 sm:p-6 flex flex-col items-center text-center">
      <div className="flex items-center gap-2 w-full justify-between">
        <h2 className="text-lg font-semibold font-heading text-[var(--color-text-primary)] mb-2">
          Your dashboard is empty.
        </h2>
        <button
          onClick={handleDismiss}
          aria-label="Dismiss"
          className="p-1 text-[var(--color-text-tertiary)] hover:text-[var(--color-accent)] rounded focus:outline-none"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.47 5.47a.75.75 0 0 1 1.06 0L9 7.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L10.06 9l2.47 2.47a.75.75 0 0 1-1.06 1.06L9 10.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L7.94 9 5.47 6.53a.75.75 0 0 1 0-1.06z"
              fill="currentColor"
              className="transition-colors"
            />
          </svg>
        </button>
      </div>
      <ul className="text-[0.8125rem] text-[var(--color-text-tertiary)] mb-4 space-y-1">
        <li>Add links by hand, pick from suggestions, or import your browser bookmarks</li>
        <li>Add widgets like news, to-dos and a scratchpad</li>
        <li>Use Edit in the top bar to rearrange or remove things.</li>
      </ul>
      <button
        onClick={onAddClick}
        className="mt-2 px-4 py-2 rounded-[var(--radius-sm)] bg-[var(--color-accent)] hover:opacity-90 text-[var(--color-text-inverse)] text-[0.8125rem] font-medium shadow-none transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)]"
      >
        Add your first link
      </button>
    </div>
  );
};

export default FTUXCard;
